/* tslint:disable */

/**
 */
export class RfidCards {
    card_email?: string;
    id?: number;
    barcode?: string;
    company_name?: string;
    card_fullname?: string;
    card_phone?: string;
    rfid?: string;
    card_address?: string;
    card_birthday?: string;
    balance?: number;
    created_at?: string;
    updated_at?: string;
}
